import React, { useState } from "react";

function ToggleDarkTheme() {
  const [isDarktheme, setDarktheme] = useState(false);

  const handleTheme = (isDark, handleStorage = true) => {
    if (isDark) {
      setDarktheme(true);
      document.body.setAttribute("data-bs-theme", "dark");
      if (handleStorage) {
        localStorage.setItem("theme", "dark");
      }
    } else {
      setDarktheme(false);
      document.body.setAttribute("data-bs-theme", "light");
      if (handleStorage) {
        localStorage.setItem("theme", "light");
      }
    }
  };

  if (localStorage.getItem("theme")) {
    if (localStorage.getItem("theme") !== "light") {
      if (!isDarktheme) {
        handleTheme(true);
      }
    }
  }

  const handleDrakMode = () => {
    if (!isDarktheme) {
      handleTheme(true);
    } else {
      handleTheme(false);
    }
  };
  return (
    <button
      onClick={handleDrakMode}
      className={`btn-toggle-dark-mode ${isDarktheme ? " active" : ""}`}
    ></button>
  );
}

export default ToggleDarkTheme;
